var map = {
	"./404.tpl": 31,
	"./home.tpl": 645,
	"./layout/404.tpl": 43,
	"./layout/common.tpl": 32,
	"./layout/footer.tpl": 646,
	"./layout/header.tpl": 647,
	"./site.tpl": 648,
	"./tutorial.tpl": 649
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 644;


//////////////////
// WEBPACK FOOTER
// ./templates /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate (\/|\\)(?!_)[\w\.\-\\]+\.tpl$
// module id = 644
// module chunks = 2